import { Controller, useFormContext } from 'react-hook-form';
import validator from 'validator';
import Input from '../../components/form/TextInput';
import type { EmailQuestion } from './types';

export default function EmailList({ question }: { question: EmailQuestion }) {
  const { control } = useFormContext();
  const id = `email-form-${question.name}`;
  return (
    <Controller
      name={question.name}
      control={control}
      defaultValue={['']}
      rules={{
        validate: (values: string[]) =>
          (values.length > 0 &&
            values.length <= 20 &&
            values.every(
              (email) => email.trim().length <= 254 && validator.isEmail(email.trim()),
            )) ||
          'Enter a valid email address in every row.',
      }}
      render={({ field, fieldState }) => {
        const values: string[] = field.value || [''];
        return (
          <fieldset
            className={`govuk-form-group${fieldState.error ? ' govuk-form-group--error' : ''}`}
          >
            <legend className="govuk-fieldset__legend">{question.title}</legend>
            {fieldState.error && (
              <p id={`${id}-error`} className="govuk-error-message">
                {fieldState.error.message}
              </p>
            )}
            {values.map((email, index) => (
              <div key={`${id}-${index}`} className="govuk-!-margin-bottom-3">
                <label className="govuk-label" htmlFor={`${id}-${index}`}>
                  Email of SCS staff member {index + 1}
                </label>
                <Input
                  id={`${id}-${index}`}
                  name={`${field.name}.${index}`}
                  type="email"
                  maxLength={254}
                  value={email}
                  ref={index === 0 ? field.ref : undefined}
                  onBlur={field.onBlur}
                  aria-invalid={!!fieldState.error}
                  aria-describedby={fieldState.error ? `${id}-error` : undefined}
                  onChange={(event) =>
                    field.onChange(
                      values.map((value, row) => (row === index ? event.target.value : value)),
                    )
                  }
                />
                {values.length > 1 && (
                  <button
                    type="button"
                    className="govuk-button govuk-button--secondary govuk-!-margin-left-2"
                    aria-label={`Remove staff member ${index + 1}`}
                    onClick={() => field.onChange(values.filter((_, row) => row !== index))}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              className="govuk-button govuk-button--secondary"
              disabled={values.length >= 20}
              onClick={() => field.onChange([...values, ''])}
            >
              Add another
            </button>
          </fieldset>
        );
      }}
    />
  );
}
